import styled, { breakpoints, theme } from '../../../styles/theme';
import { CharacteristicsStyled } from '../CharacteristicsStyled';
import { rem } from 'polished';
import media from '../../../styles/media';
import { CharacteristicsProps } from './../index';

export const CharacteristicsStyledOV = styled(CharacteristicsStyled)`
    .tires-icon.icon-wrapper svg {
        width: ${rem(22)};
        height: ${rem(22)};
        top: ${rem(0)};
        path {
            fill: ${({ theme }) => theme.colors.black};
        }
    }
    .details {
        .bullet-points {
            li {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
            }
        }
    }
    .characteristics-grid-col {
        @media (max-width: ${breakpoints.md}px) {
            padding-left: unset !important;
            padding-right: unset !important;
        }

        .technicalWrapper {
            padding: 0;
        }

        .technicalTitle {
            margin-top: ${rem('20px')};
            font-size: ${({ theme }) => theme.fontSizes.h2};
            text-transform: none;
            font-weight: normal;

            @media (min-width: ${breakpoints.md}px) {
                padding-left: ${rem('20px')};
                padding-right: ${rem('20px')};
            }

            @media (max-width: ${breakpoints.md}px) {
                padding-left: unset !important;
                padding-right: unset !important;
                display: flex;
                flex-direction: column;

                span {
                    border-right: unset !important;
                    padding-left: unset !important;
                    padding-right: unset !important;
                }
            }
        }
    }

    .characteristics-col-title {
        @media (max-width: ${breakpoints.xs}px) {
            max-width: 100%;
        }
    }

    .technicalSubtitle {
        margin-top: ${rem('10px')};
        text-transform: none;

        @media (min-width: ${breakpoints.md}px) {
            padding-left: ${rem('20px')};
            padding-right: ${rem('20px')};
        }

        @media (max-width: ${breakpoints.xs}px) {
            padding-left: 0;
            padding-right: 0;
        }
    }

    .technicalDetails {
        text-transform: none;
        line-height: 1.2;
        margin-bottom: ${rem('36px')};
        font-size: ${rem('24px')};

        &-mainBlock {
            padding-left: 0;
            @media (max-width: ${breakpoints.sm}px) {
                padding-right: 0;
            }
        }

        ${(prop) =>
            (prop as CharacteristicsProps).isInnered
                ? `
                    padding-left: 20px;
                    padding-right: 20px;
                `
                : `
                @media (min-width: ${breakpoints.md}px) {
                    padding-left: ${rem('50px')};
                    padding-right: ${rem('50px')};
                }
                
                @media (max-width: ${breakpoints.md}px) {
                    padding-left: ${rem('20px')};
                    padding-right: ${rem('20px')};
                }
        `};
    }

    .featureTitleWide {
        text-transform: none;
        font-size: ${({ theme }) => theme.fontSizes.h4};
        border-top: none;
        margin-bottom: ${rem(10)};
        margin-top: 0;
        padding-top: 0;

        @media (max-width: ${breakpoints.sm}px) {
            padding-left: 0;
        }
    }

    .technicalFeaturesModule {
        @media (max-width: ${breakpoints.sm}px) {
            margin: 0;
        }
    }

    .featureList {
        color: ${({ theme }) => theme.colors.grey1};
        padding: 0 0.0625rem 0;

        li {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            line-height: ${({ theme }) => theme.lineHeights.textBig};
            color: ${({ theme }) => theme.colors.blue1};
            position: relative;
            display: flex;
            align-items: flex-start;

            &::before {
                content: '';
                margin: 0;
            }
        }
    }

    .featureTitle {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        text-transform: none;

        @media (max-width: ${breakpoints.xs}px) {
            padding-left: ${rem(5)};
        }
    }

    .legalText {
        a {
            color: inherit;
        }

        @media (max-width: ${breakpoints.xs}px) {
            margin: 0;
        }
    }

    .Collapsible {
        padding-left: 20px;
        padding-right: 20px;
    }

    .Collapsible__trigger {
        background: none;
        padding: 0;
    }

    .technicalWrapper {
        padding: ${rem(12)} 0;
        border-top: 1px solid ${({ theme }) => theme.colors.grey20};

        @media (min-width: ${breakpoints.xs}px) {
            border-top: none;
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey18};
            margin-bottom: ${rem('24px')};
        }
    }
    
    .technicalDetails {
        &-mainBlock {
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey18};
        }
    }

    .collapsibleTriggerHeader {
        @media (max-width: ${breakpoints.xs}px) {
            .triggerIcon {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: ${rem(10)};
                width: ${rem(20)};
                height: ${rem(20)};

                &.isExpanded {
                    background-color: ${({ theme }) => theme.colors.primary};
                }

                svg {
                    path {
                        stroke: ${({ theme }) => theme.colors.black2};
                        fill: ${({ theme }) => theme.colors.black2};
                    }
                }
            }
        }
    }

    .characteristicsGrid {
        @media (max-width: ${breakpoints.xs}px) {
            padding-left: ${rem(24)};
            padding-right: ${rem(24)};
        }

        @media (min-width: ${breakpoints.md}px) and (max-width: calc(${breakpoints.md}px - 0.1px)) {
            max-width: 90% !important;
        }
    }

    .featureList li {
        color: ${({ theme }) => theme.colors.grey1};
    }

    .environmentalWrapper {
        div {
            flex-basis: auto !important;
        }

        & > div {
            width: auto;
        }
        ${(prop) =>
            (prop as CharacteristicsProps).isInnered
                ? ``
                : `
                @media (min-width: ${breakpoints.md}px) {
                    div:first-of-type .environmentalBlock {
                        border-right: ${rem(2)} solid ${theme.colors.black2};
                        padding-right: ${rem(20)}
                    }
                }
        `};
    }

    .environmentalBlock:first-of-type .techBlock {
        padding: unset !important;
    }

    .environmentalBlockBasket {
        ${media.xs`
              flex-direction: row;
              justify-content: end;
        `}

        &:last-of-type .techBlock {
            margin-right: 3rem;
        }

        &:first-of-type .environmentalItem {
            margin-left: 3rem;
        }

        @media (min-width: ${breakpoints.md}px) {
            &:first-of-type .environmentalItem {
                margin-left: 3rem;
            }
            .techBlock {
                margin-left: 1rem;
                margin-right: 1rem;
            }

            .environmentalItem {
                margin-left: 1rem;
                margin-right: 1rem;
            }
        }

        @media (max-width: ${breakpoints.xs}px) {
            padding-top: ${rem('20px')};
            padding-bottom: ${rem('10px')};

            .environmentalItem {
                margin-left: 0;
                margin-right: 0;
            }
        }
    }

    :nth-of-type(2) .specificationBlock {
        margin-top: 2rem;
        border-top: 1px solid grey;
        padding-top: 2rem;
    }

    .specificationBlock {
        position: relative;
        margin-top: ${rem(-1)};
        padding-left: 0;

        @media (max-width: ${breakpoints.sm}px) {
            padding-right: 0;
        }

        ${media.xs`
            column-gap: 18%;
            columns: 2;
                &:before {
                content: '';
                display: block;
                height: ${rem(1)};
                background: ${rem(1)} solid white;
                left: 0;
                right: 0;
                position: absolute;
            }
            border-bottom: none;
        `}
    }

    .hideTechnicalDetail {
        margin: 0 auto;
        width: 100%;
        a {
            cursor: pointer;
            color: ${({ theme }) => theme.colors.black2};
            font-weight: bold;
        }

        .icon-wrapper {
            transform: rotate(90deg);
            margin-top: 1rem;

            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black2};
                    stroke-width: 2px;
                }
            }
        }
    }

    @media (max-width: ${breakpoints.xs}px) {
        .techLabel {
            margin-bottom: ${rem('3px')};
        }
    }
`;
